import defaultEnTranslation from './default/en.json';
import stepsEnTranslation from './steps/en.json';
import sharedStepsEn from './steps/shared/en.json';

const enTranslation = {
  default: defaultEnTranslation,
  shared: sharedStepsEn,
  steps: stepsEnTranslation
};

export default enTranslation;
